export enum MediaItemType {
  REGULAR = 'regular',
  INSPECTION = 'inspection',
}

export interface MediaItem {
  source: string;
  thumbSource?: string;
  mediaType: 'image' | 'video';
  type: MediaItemType;
}
